import React from 'react';
import FeatureCards from "../../../components/FeatureCards/FeatureCards";
import CTA from "../../../components/Constant/cta/CTA";
import TimelineSection from "../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../components/WhySection/WhySection";
import LocationTimeline from "../../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../../components/ServiceCards/ServiceCards ";

export default function CryptoLicenseAnjouan (){

    return (
        <main className='main'>

            <IntroSection
                title="Crypto License – Anjouan (Comoros)"
                subtitle="Launch Your Crypto Business with AOFA Licensing"
                description =
                        "
                            Mwali (Mohéli, Comoros), through the Mwali International Services Authority (MISA), offers Crypto & Virtual Asset Licenses for companies seeking a credible offshore base. With strong regulatory oversight, moderate requirements, and global recognition, Mwali is a leading offshore hub for exchanges, wallet providers, token projects, and blockchain firms.
                        "
                badges={
                    [
                        "Crypto Exchange License",
                        "Wallet & Custodian License",
                        "VASP Registration",
                        "Tokenization & DeFi"
                    ]
                }
                buttonText="Request a Mwali Crypto License Proposal →"
                buttonLink="/quote"
                imageSrc={require("../../../assets/images/services/crypto-license-western-anjouan-hero.png")}
                imageAlt="Intro"
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title='Why Choose Anjouan?'
                        blocks={[
                            {
                                items:
                                    [
                                        {
                                            "title": "No Capital Requirement",
                                            "text": "Unlike Malta, Estonia, or Gibraltar."
                                        },
                                        {
                                            "title": "Fast Licensing",
                                            "text": "Approval in 4–6 weeks."
                                        },
                                        {
                                            "title": "Affordable",
                                            "text": "Among the lowest licensing fees worldwide."
                                        },
                                        {
                                            "title": "Operate Globally",
                                            "text": "AOFA licenses designed for international use."
                                        },
                                        {
                                            "title": "Crypto-Friendly",
                                            "text": "Ideal for exchanges, wallets, DeFi, and token projects."
                                        }
                                    ]
                            }
                        ]}
                    />

                    <LocationTimeline
                        title="What the License Covers"
                        subtitle='With an Anjouan Crypto License, you can operate:'
                        item={
                            [
                                {
                                    "title": "Crypto Exchanges (CEX & DEX)",
                                    "text": "Spot, margin, and derivatives trading."
                                },
                                {
                                    "title": "Wallet & Custody Services",
                                    "text": "Hot/cold storage solutions."
                                },
                                {
                                    "title": "Virtual Asset Service Provider (VASP)",
                                    "text": "FATF-compliant structure."
                                },
                                {
                                    "title": "ICO/IEO/STO Token Issuance",
                                    "text": "Legally launch coins and tokenized assets."
                                },
                                {
                                    "title": "DeFi & NFT Platforms",
                                    "text": "Decentralized applications, marketplaces, and games."
                                },
                                {
                                    "title": "Crypto Payment Gateways",
                                    "text": "Process payments for global merchants."
                                }
                            ]
                        }
                    />


                    <InfoBlocks
                        title="Benefits of an Anjouan Crypto License"
                        blocks={[
                            {
                                items:
                                    [
                                        {
                                            "title": "Global Legitimacy",
                                            "text": "Adds credibility with PSPs, partners, and investors."
                                        },
                                        {
                                            "title": "Banking & PSP Access",
                                            "text": "Easier onboarding with EMIs and payment processors."
                                        },
                                        {
                                            "title": "Fast & Affordable",
                                            "text": "Far cheaper and quicker than EU regulators."
                                        },
                                        {
                                            "title": "Compliance-Friendly",
                                            "text": "AML/KYC tailored to crypto businesses."
                                        },
                                        {
                                            "title": "Scalable",
                                            "text": "Start as an exchange, expand into custody or tokenization."
                                        }
                                    ]
                            }
                        ]}
                    />


                    <ServiceCards
                        title='Licensing Process'
                        services={
                            [
                                {
                                    "title": "Consultation & Planning",
                                    "text": "Define your crypto business model."
                                },
                                {
                                    "title": "Company Incorporation",
                                    "text": "Establish an IBC in Anjouan."
                                },
                                {
                                    "title": "Compliance Setup",
                                    "text": "AML/KYC manuals, risk policy, business plan."
                                },
                                {
                                    "title": "Application Filing",
                                    "text": "Offshore Advisory submits to AOFA."
                                },
                                {
                                    "title": "Approval & License Grant",
                                    "text": "Typically within 4–6 weeks."
                                }
                            ]
                        }
                        />

                    {/* Timeline */}
                    <TimelineSection
                        title='Timeline & Costs'
                        items={[
                            {
                                name: "Timeline",
                                duration: "4–6 weeks",
                            },
                            {
                                name: "Setup Cost",
                                description: "from USD 19,000–20,000+.",
                            },
                            {
                                name: "Annual Renewal Fees",
                                description: "very competitive vs Malta, Estonia, or Gibraltar.",
                            }
                        ]
                    }
                    />

                    <DetailsSection
                        title='Why Offshore Advisory?'
                        items={
                            [
                                {
                                    text: "Recognized AOFA agent with crypto licensing expertise."
                                },
                                {
                                    text: "End-to-end services: incorporation, compliance, license filing, PSP access."
                                },
                                {
                                    text: "Connections to crypto-friendly EMI and banking partners."
                                },
                                {
                                    text: "Technical integration: white-label exchanges, wallet and custody platforms."
                                },
                                {
                                    text: "Guidance for tokenization, DeFi and NFT projects."
                                }
                            ]
                        }
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    {/* Final CTA */}
                    <CTA
                        title="Ready to launch your crypto venture?"
                        description="Anjouan offers one of the fastest, most affordable, and crypto-friendly licenses worldwide."
                        buttonText="Book an Anjouan Crypto License Consultation →"
                        buttonLink="/quote"
                    />
                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "Is there a capital requirement?",
        content: [
            { type: "answer", text: "No — AOFA requires no paid-up capital, unlike most EU regulators." },
        ],
    },
    {
        question: "How long does licensing take?",
        content: [
            { type: "answer", text: "Typically 4–6 weeks, one of the fastest crypto licensing approvals worldwide." },
        ],
    },
    {
        question: "Can I operate globally under this license?",
        content: [
            { type: "answer", text: "Yes — AOFA licenses are designed for international markets." },
        ],
    },
    {
        question: "Can I issue tokens or run a DeFi project?",
        content: [
            { type: "answer", text: "Yes — tokenization, ICO/STO/IEO, DeFi, and NFT projects are supported." },
        ],
    },
    {
        question: "Does the license support wallets & custody?",
        content: [
            { type: "answer", text: "Yes — you can run hot/cold wallets and digital asset custody services." },
        ],
    },
];


const testimonialsData =
    [
        {
            quote: "We obtained an Anjouan crypto license in 5 weeks. Offshore Advisory helped us with PSP setup and a white-label exchange.",
            author: "Alex D.",
            role: "Exchange Founder"
        },
        {
            quote: "Anjouan was the perfect jurisdiction for our DeFi platform. Offshore Advisory handled everything professionally.",
            author: "Sofia M.",
            role: "Blockchain CEO"
        }
    ]
;